import { offlineDatabase } from '../database/offlineDatabase/offlineDatabase';
import { createOfflineCommonRepository } from './common/createOfflineCommonRepository';

export const offlineSalesRepresentativeRepository = {
  ...createOfflineCommonRepository(() => offlineDatabase.salesRepresentatives, ['name', 'code']),
  getSalesRepFromCurrentUser: () => {
    return offlineDatabase.salesRepresentatives.filter((salesRep) => salesRep.isMine).first();
  },
};
